import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    createCategory,
    reorderCategories,
    toggleCategoryActive,
    updateCategory,
} from '../api/settingsApi';

// Settings category mutations are not driven by SignalR, so each mutation
// hook invalidates the relevant React Query caches directly on success.
// Both the dropdown cache ['categories', targetType] and the admin list
// cache ['adminCategories', targetType] are invalidated after every change.

function invalidateAll(queryClient, targetType) {
    queryClient.invalidateQueries({ queryKey: ['categories',      targetType] });
    queryClient.invalidateQueries({ queryKey: ['adminCategories', targetType] });
}

export function useCreateCategory() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => createCategory(data),
        onSuccess: (_, variables) => invalidateAll(queryClient, variables.targetType),
    });
}

export function useUpdateCategory() {
    const queryClient = useQueryClient();
    return useMutation({
        // variables: { id, name, targetType }
        mutationFn: ({ id, name }) => updateCategory(id, { name }),
        onSuccess: (_, variables) => invalidateAll(queryClient, variables.targetType),
    });
}

export function useToggleCategoryActive() {
    const queryClient = useQueryClient();
    return useMutation({
        // variables: { id, targetType }
        mutationFn: ({ id }) => toggleCategoryActive(id),
        onSuccess: (_, variables) => invalidateAll(queryClient, variables.targetType),
    });
}

export function useReorderCategories() {
    const queryClient = useQueryClient();
    return useMutation({
        // variables: { targetType, orderedIds }
        mutationFn: (data) => reorderCategories(data),
        onSuccess: (_, variables) => invalidateAll(queryClient, variables.targetType),
    });
}
